import { useEffect, useState } from "react"

import { DynamicFormTemplate } from "../../utilities"
import { Operations, Materials, Constant } from "../../constants";
import { useTranslation } from 'react-i18next';

const OperationForm = (props) => {
    const { t: translate } = useTranslation();
    const {
        isHidden,
        formData,
        error
    } = props

    const autoCompleteField = {
        "exploitant-raisonsociale": true,
        "exploitant-identifiant_client": true
    }
    const notAutoCompleteOtherField = {
        "exploitant-identifiant_client": true,
    }
    const [isPicked, setIsPicked] = useState(false)
    const [formElements, setFormElements] = useState([])
    const [operationInfo, setOperationInfo] = useState({})
    const [errorInput, setErrorInput] = useState({})

    const generateForm = () => {
        const form = []
        formData.forEach(element => {
            if (autoCompleteField[element.name]) {
                updateAutoCompleteSchema(element)
            }

            form.push(element)
        })

        setFormElements(form)
    }

    const updateAutoCompleteSchema = (element) => {
        element.typehtml = "autocomplete"
        element.allowFreeText = true
        element.displayAllOption = false

        if (notAutoCompleteOtherField[element.name]) {
            const uniqueItems = new Set(Operations.getOperation().map(m => m[element.name.split("-").join("_")]))
            const options = []
            uniqueItems.forEach(o => o ? options.push({ label: o, id: o }) : null)
            element.options = options
            element.key = ""
        }
        else {
            const options = Operations.getOperation().map(m => ({ label: m[element.name.split("-").join("_")], id: m["exploitant_id"] }))
            element.options = options
            element.key = "operation"
        }
    }

    const renderSearchResultInfo = () => {
        const rows = []
        formElements.forEach(characteristic => {
            if (characteristic.typehtml === 'hidden') {
                return
            }
            const propertyName = characteristic.name.split("-").join("_")
            rows.push(<div key={characteristic.name} className="form-group form-element">
                <p htmlFor={characteristic.name}>{characteristic.label} {characteristic.requis ? <span className='text-danger'>*</span> : null}</p>
                <p className="bold">{operationInfo[propertyName]}</p>
            </div>)
        })

        return rows
    }

    const changeOperation = (e) => {
        setIsPicked(false)
        setOperationInfo({})
    }

    const modifiesOperation = () => {
        setIsPicked(false)
    }

    const setOperations = (e) => {
        const { key, name, data } = e.detail
        if (key === "material") {
            const materials = Materials.getMaterials()
            //const propertyName = name.split("-").join("_")
            const filteredMaterials = materials.filter(m => m["materiel_id"] === data.id)
            if (filteredMaterials.length === 0) {
                return
            }

            const material = filteredMaterials[0]
            if (!material["materiel_exploitant_id"]) {
                setIsPicked(false)
                setOperationInfo({})
                return
            }
            const operations = Operations.getOperation()
            operations.forEach(operation => {
                if (operation.exploitant_id === material["materiel_exploitant_id"]) {
                    setIsPicked(true)
                    setOperationInfo({ ...operation })
                }
            })
        }

        if (key === "operation") {
            setIsPicked(true)
            const operations = Operations.getOperation()
            //const propertyName = name.split("-").join("_")
            const filteredOperation = operations.filter(m => m["exploitant_id"] === data.id)
            setOperationInfo({ ...filteredOperation[0] })
        }
    }

    useEffect(() => {
        if (error.length > 0) {
            let errorInputTemp = {}
            error.forEach(e => {
                errorInputTemp = { ...errorInputTemp, [e]: true }
            })
            setErrorInput(errorInputTemp)
        }
    }, [error])


    useEffect(() => {
        generateForm()

        window.addEventListener(Constant.event.selectAutoCompleteOption, setOperations)
        window.addEventListener(Constant.event.resetOperation, changeOperation)

        return () => {
            window.removeEventListener(Constant.event.selectAutoCompleteOption, setOperations)
            window.removeEventListener(Constant.event.resetOperation, changeOperation)
        }
    }, [])

    return <div style={{ display: isHidden ? "none" : "block" }}>
        {formElements.length > 0 ? <div className="form-container">
            <h4 className="bold form-group">{translate('equipmentOperator')}</h4>
            {isPicked ? <button type="button" className="form-group" onClick={changeOperation}>{translate('createOrChangeOperator')}</button> : null}
            {!isPicked ?
                <DynamicFormTemplate isHidden={false} formData={formElements} defaultValue={operationInfo} error={errorInput} />
                : <div>
                    <DynamicFormTemplate isHidden={true} formData={formElements} defaultValue={operationInfo} />
                    {renderSearchResultInfo()}
                </div>
            }
            {isPicked ? <button type="button" className="form-group" onClick={modifiesOperation}>{translate('changeContactInfo')}</button> : null}
        </div> : null}
    </div>
}

export default OperationForm;